import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractAccountOperation from "./AbstractAccountOperation.js";

/**
 * Year to date, sums all transactions from the start of the context year to the end of the context period included.
 */
export default class YearToDateAccountOperation extends AbstractAccountOperation {
	getName() {
		return _("Year to Date");
	}

	getShortName() {
		return _("YTD");
	}

	static getType() {
		return "YearToDateAccountOperation";
	}

	static getOperationType() {
		return "YearToDate";
	}
}
